import * as Mutations from './mutations';
import { LocationsService } from '../../../common/services/settings/locations.service';
import { PaginationParams } from '../../../common/utils/pagination-params';
import router from '../../../router'
import * as Routes from '../../../router/routes';
import { clearAllSelected } from '@/store/modules/page/reset';

export const LocationsModule = {
    state: {
        locations: null,
        locationId: null,
        location: null,
        allLocations: null
    },
    mutations: {
        [Mutations.SET_LOCATIONS] (state, locations) {
            state.locations = locations;
        },

        [Mutations.SET_LOCATION_ID] (state, locationId) {
            state.locationId = locationId;
        },

        [Mutations.REMOVE_LOCATION_ID] (state) {
            state.locationId = null;
        },

        [Mutations.SET_LOCATION] (state, location) {
            state.location = location;
        },

        [Mutations.REMOVE_LOCATION] (state) {
            state.location = null;
        },

        [Mutations.SET_SCHOOL_LOCATIONS] (state, locations) {
            state.allLocations = locations;
        }
    },
    actions: {
        async getLocations(context) {
            const { data: { content, pageable, totalPages, totalElements, numberOfElements } } =
                await LocationsService.getLocations(context.getters.schoolId,
                    PaginationParams.createParams({
                        size: context.getters.pageSize,
                        page: context.getters.pageNumber,
                        sort: context.getters.sortBy,
                        direction: context.getters.direction,
                        query: context.getters.searchQuery,
                        filters: {
                            ...context.getters.filters
                        }
                    }));
            context.commit(Mutations.SET_LOCATIONS, content);
            context.dispatch('configPagination', {
                ...pageable,
                numberOfElements,
                totalElements,
                totalPages,
                callback: () => {
                    return context.dispatch('getLocations');
                }
            });
            context.dispatch('resetSelectedItems');
        },

        async getAllLocations(context) {
            const { data } = await LocationsService.getAllLocations(context.getters.schoolId);
            context.commit(Mutations.SET_SCHOOL_LOCATIONS, data);
        },

        async getLocation(context) {
            const { data } = await LocationsService.getLocation(context.getters.schoolId, context.getters.locationId);
            context.commit(Mutations.SET_LOCATION, data);
        },

        async addLocation(context, form) {
            try {
                context.dispatch('showSpinner');
                await LocationsService.addLocation(context.getters.schoolId, form);
                context.dispatch('getLocations');
            } finally {
                setTimeout(() => {
                    context.dispatch('hideSpinner');
                });
            }
        },

        async bulkUploadLocations(context, file) {
            await LocationsService.addLocationsBulk(context.getters.schoolId, file);
            if (router.app._route.name === Routes.CLASS_FORM) {
                await context.dispatch('getAllLocations');
            }
            else {
                await context.dispatch('getLocations');
            }
        },

        async editLocation(context, form) {
            try {
                context.dispatch('showSpinner');
                await LocationsService.editLocation(context.getters.schoolId, context.getters.locationId, form);
                await context.dispatch('getLocations');
                context.dispatch('unstageLocation');
            } finally {
                context.dispatch('hideSpinner');
            }
        },

        async deleteLocation(context, locationId) {
            await context.dispatch('deleteLocations', [ locationId ]);
        },

        async deleteMultipleLocations(context) {
            await context.dispatch('deleteLocations', context.getters.selected);
            context.dispatch('resetSelectedItems');
        },

        async deleteLocations(context, locationIds) {
            await LocationsService.deleteMultipleLocations(context.getters.schoolId, locationIds);
            if (locationIds.length === context.getters.locations.length) {
                context.dispatch('openPreviousPage');
            }
            clearAllSelected();
            await context.dispatch('getLocations');
        },

        async toggleLocationStatus(context, LOCATIONId) {
            await LocationsService.toggleLocationStatus(context.getters.schoolId, LOCATIONId);
            context.dispatch('resetFilter');
            await context.dispatch('getLocations');
        },

        prepareLocation(context, payload) {
            context.commit(Mutations.SET_LOCATION_ID, payload.locationId);
            if (payload.type === 'edit') {
                context.dispatch('openModal', {
                    modalName: 'LocationModal',
                    callback: () => context.dispatch('unstageLocation')
                });
            }
            else {
                context.dispatch('openModal', { modalName: 'MigrateChildrenModal' });
            }
            context.dispatch('getLocation');
        },

        unstageLocation(context) {
            context.commit(Mutations.REMOVE_LOCATION_ID);
            context.commit(Mutations.REMOVE_LOCATION);
        }
    },
    getters: {
        locations: state => state.locations,

        locationId: state => state.locationId,

        location: state => state.location,

        allLocations: state => state.allLocations
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/locations/locations.module.js